import { z } from 'zod';

// ページネーション用の共通バリデーション
// string → number 変換 + 1以上の整数チェック
const parsePage = (val: string, ctx: z.RefinementCtx): number => {
  const num = Number(val);
  if (Number.isNaN(num)) {
    ctx.addIssue({
      code: 'custom',
      message: 'Page must be a valid number',
    });
    return z.NEVER;
  }
  if (!Number.isInteger(num) || num < 1) {
    ctx.addIssue({
      code: 'custom',
      message: 'Page must be a positive integer',
    });
    return z.NEVER;
  }
  return num;
};

// ページネーション用スキーマ
// クエリパラメータの page 文字列を数値に変換し、1以上の整数であることを検証する
export const pageSchema = z.string().transform(parsePage);

/**
 * ページネーションのためのskip/take値を計算する
 *
 * ## ユースケース
 * この関数は、zodスキーマによるバリデーションが完了した後に呼び出されることを前提としています。
 * 呼び出し元で page と perPage が正の整数であることが保証されている必要があります。
 *
 * @param page - ページ番号（1以上の整数、呼び出し元で保証される）
 * @param perPage - 1ページあたりの件数（1以上の整数、呼び出し元で保証される）
 * @returns skip（スキップする件数）とtake（取得する件数）
 */
const calculatePagination = (page: number, perPage: number): { skip: number; take: number } => {
  return {
    skip: (page - 1) * perPage,
    take: perPage,
  };
};

export default calculatePagination;
